import React from "react";
import ctaBg from "../../assets/landing/img/bg/cta_bg_8.jpg";

const Cta = () => (
  <section
    className="overflow-hidden position-relative z-index-common mb-5"
    data-pos-for=".footer-wrapper"
    data-sec-pos="bottom-half"
  >
    <div className="container th-container4">
      <div
        className="cta-sec8 background-image bg-theme"
        style={{
          backgroundImage: `url(${ctaBg})`,
        }}
      >
        <div className="title-area mb-0">
          <h2 className="sec-title text-white">
            Trải nghiệm sự tiện lợi ngay hôm nay cùng Pay2S
          </h2>
          <p className="sec-text text-white">
            Tiên phong trong công nghệ thanh toán không sử dụng tiền mặt, tự
            động hóa quy trình thanh toán, Open Banking API
          </p>
        </div>
        <div className="btn-wrap">
          <a href="/client/signup" className="th-btn style5 style-radius">
            Đăng ký tài khoản ngay
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default Cta;
